export const Post = {
  postViewerEventUrl: 'https://guide.anotherclass.co.kr/event-share-anotherclass/',
  textColors: [
    'default',
    'red',
    'orange',
    'yellow',
    'green',
    'blue',
    'purple',
    'gray',
  ] as const,
  bgColors: ['none', 'yellow', 'gray'] as const,
};
